import { IDataGenericText } from "@app/interfaces/idata-grouped";
import { Select2OptionData } from "ng-select2";

export const LEVEL_LIST: Array<IDataGenericText> =
    [
        { id: 1, text: 'Jardín Infantil / Sala Cuna' },
        { id: 2, text: 'Pre-kínder/Kínder' },
        { id: 3, text: 'Básica (1° a 6° básico)' },
        { id: 4, text: 'Media (7° a IV ° medio)' },
    ];

export const job_level: Array<Select2OptionData> =
    [
        { id: '1', text: 'Jardín Infantil / Sala Cuna' },
        { id: '2', text: 'Pre-kínder/Kínder' },
        { id: '3', text: 'Básica (1° a 6° básico)' },
        { id: '4', text: 'Media (7° a IV ° medio)' },
    ];

export const salary_level: Array<Select2OptionData> =
    [
        { id: '1', text: "Medio Menor – Medio Mayor (Jardín Infantil)" },
        { id: '2', text: "Transición (Prekínder – Kínder)" },
        { id: '3', text: "Primer Ciclo (1º a 4º básico)" },
        { id: '4', text: "Segundo Ciclo (5º a 8º básico)" },
        { id: '5', text: "Enseñanza Media (Iº a IVº medio)" },
    ];
